import { ComponentType } from "react";

import { Routes } from "@ctypes";
import { AccountHorizonRoute } from "@routes/AccountHorizonRoute";
import { AccountTypeRoute } from "@routes/AccountTypeRoute";
import { AddBeneficiaryTypeRoute } from "@routes/AddBeneficiaryTypeRoute";
import { AddChildRoute } from "@routes/AddChildRoute";
import { AssetRangeRoute } from "@routes/AssetRangeRoute";
import { BankLinkingRoute } from "@routes/BankLinkingRoute";
import { BeneficiarySsnRoute } from "@routes/BeneficiarySsnRoute";
import { ChildDepositRoute } from "@routes/ChildDepositRoute";
import { CitizenshipRoute } from "@routes/CitizenshipRoute";
import { DateOfBirthRoute } from "@routes/DateOfBirthRoute";
import { EmailCodeVerificationRoute } from "@routes/EmailCodeVerificationRoute";
import { EmailRoute } from "@routes/EmailRoute";
import { EmployerAddressConfirmationRoute } from "@routes/EmployerAddressConfimationRoute";
import { EmployerAddressRoute } from "@routes/EmployerAddressRoute";
import { EmployerAutofillRoute } from "@routes/EmployerAutofillRoute";
import { EmploymentRoute } from "@routes/EmploymentRoute";
import { ForgotPasswordConfirmationRoute } from "@routes/ForgotPasswordConfirmationRoute";
import { ForgotPasswordRoute } from "@routes/ForgotPasswordRoute";
import { GoalDepositRoute } from "@routes/GoalDepositRoute";
import { GoalNameRoute } from "@routes/GoalNameRoute";
import { GoalTypeRoute } from "@routes/GoalTypeRoute";
import { InsufficientBankBalanceRoute } from "@routes/InsufficientBankBalanceRoute";
import { InvestmentDownturnReactionRoute } from "@routes/InvestmentDownturnReactionRoute";
import { InvestmentPriorityRoute } from "@routes/InvestmentPriorityRoute";
import { LoginRoute } from "@routes/LoginRoute";
import { MaritalStatusRoute } from "@routes/MaritalStatusRoute";
import { NameRoute } from "@routes/NameRoute";
import { PhoneLoginInputRoute } from "@routes/PhoneLoginInputRoute";
import { PhoneLoginRoute } from "@routes/PhoneLoginRoute";
import { PhoneNumberRoute } from "@routes/PhoneNumberRoute";
import { PhoneVerificationRoute } from "@routes/PhoneVerificationRoute";
import { ResidentialAddressConfirmationRoute } from "@routes/ResidentialAddressConfirmationRoute";
import { ResidentialAddressRoute } from "@routes/ResidentialAddressRoute";
import { ReviewProfileRoute } from "@routes/ReviewProfileRoute";
import { SignUpRoute } from "@routes/SignUpRoute";
import { SsnRoute } from "@routes/SsnRoute";
import { TaxFlexibilityRoute } from "@routes/TaxFlexibilityRoute";
import { TaxGainHarvestRoute } from "@routes/TaxGainHarvestRoute";
import { TrumpAccountCheckRoute } from "@routes/TrumpAccountCheckRoute";
import { TrumpAccountSetupRoute } from "@routes/TrumpAccountSetupRoute";
import { TrumpSidecarCurrentContributionRoute } from "@routes/TrumpSidecarCurrentContributionRoute";
import { TrumpSidecarIntroductionRoute } from "@routes/TrumpSidecarIntroductionRoute";
import { TrumpSidecarRecommendedContributionRoute } from "@routes/TrumpSidecarRecommendedContributionRoute";
import { TrumpSidecarTaxCalculationRoute } from "@routes/TrumpSidecarTaxCalculationRoute";
import { UnsupportedBankRoute } from "@routes/UnsupportedBankRoute";
import { VerifiedRoute } from "@routes/VerifiedRoute";

import { EmailScreen } from "./screens/EmailScreen";
import { GetStartedScreen } from "./screens/GetStartedScreen";
import { GreetingScreen } from "./screens/GreetingScreen";
import { LoginOptionsScreen } from "./screens/LoginOptionsScreen";
import { NameScreen } from "./screens/NameScreen";
import { PreferredNameScreen } from "./screens/PreferredNameScreen";
import { OnboardingCompleteScreen } from "./screens/OnboardingCompleteScreen";
import { PartnerExistingAccountScreen } from "./screens/PartnerExistingAccountScreen";
import { SecureAccountScreen } from "./screens/SecureAccountScreen";
import { WelcomeScreen } from "./screens/WelcomeScreen";

export const STEP_COMPONENTS: Record<string, ComponentType> = {
  [Routes.Auth]: WelcomeScreen,
  [Routes.GetStarted]: GetStartedScreen,
  [Routes.EntryName]: NameScreen,
  [Routes.EntryPreferredName]: PreferredNameScreen,
  [Routes.EntryGreeting]: GreetingScreen,
  [Routes.SecureAccountIntro]: SecureAccountScreen,

  [Routes.EntryEmail]: EmailScreen,
  [Routes.EntryPhone]: PhoneLoginInputRoute,
  [Routes.Login]: LoginOptionsScreen,
  [Routes.SignUp]: SignUpRoute,
  [Routes.EmailLogin]: LoginRoute,
  [Routes.PhoneLoginInput]: PhoneLoginInputRoute,
  [Routes.PhoneLoginVerification]: PhoneLoginRoute,
  [Routes.EmailCodeVerification]: EmailCodeVerificationRoute,
  [Routes.PartnerExistingAccount]: PartnerExistingAccountScreen,
  [Routes.ForgotPassword]: ForgotPasswordRoute,
  [Routes.ForgotPasswordConfirmation]: ForgotPasswordConfirmationRoute,
  [Routes.Email]: EmailRoute,
  [Routes.DateOfBirth]: DateOfBirthRoute,
  [Routes.PhoneNumber]: PhoneNumberRoute,
  [Routes.PhoneVerification]: PhoneVerificationRoute,
  [Routes.Name]: NameRoute,
  [Routes.ResidentialAddress]: ResidentialAddressRoute,
  [Routes.ResidentialAddressConfirmation]: ResidentialAddressConfirmationRoute,
  [Routes.Citizenship]: CitizenshipRoute,
  [Routes.Ssn]: SsnRoute,
  [Routes.InvestmentPriority]: InvestmentPriorityRoute,
  [Routes.InvestmentDownturnReaction]: InvestmentDownturnReactionRoute,
  [Routes.MaritalStatus]: MaritalStatusRoute,
  [Routes.OnboardingComplete]: OnboardingCompleteScreen,
  [Routes.ReviewProfile]: ReviewProfileRoute,
  [Routes.Prefill]: VerifiedRoute,
  [Routes.Employment]: EmploymentRoute,
  [Routes.EmployerAddress]: EmployerAddressRoute,
  [Routes.EmployerAddressAutofill]: EmployerAutofillRoute,
  [Routes.EmployerAddressConfirmation]: EmployerAddressConfirmationRoute,
  [Routes.AssetsRange]: AssetRangeRoute,
  [Routes.AddBeneficiaryType]: AddBeneficiaryTypeRoute,
  [Routes.AddChild]: AddChildRoute,
  [Routes.BeneficiarySsn]: BeneficiarySsnRoute,
  [Routes.GoalType]: GoalTypeRoute,
  [Routes.TaxFlexibility]: TaxFlexibilityRoute,
  [Routes.GoalName]: GoalNameRoute,
  [Routes.TrumpAccountCheck]: TrumpAccountCheckRoute,
  [Routes.TrumpAccountSetup]: TrumpAccountSetupRoute,
  [Routes.TrumpSidecarIntroduction]: TrumpSidecarIntroductionRoute,
  [Routes.TrumpSidecarCurrentContribution]: TrumpSidecarCurrentContributionRoute,
  [Routes.TrumpSidecarTaxCalculation]: TrumpSidecarTaxCalculationRoute,
  [Routes.TrumpSidecarRecommendedContribution]: TrumpSidecarRecommendedContributionRoute,
  [Routes.AccountType]: AccountTypeRoute,
  [Routes.AccountHorizon]: AccountHorizonRoute,
  [Routes.GoalDeposit]: GoalDepositRoute,
  [Routes.ChildDeposit]: ChildDepositRoute,
  [Routes.BankLinking]: BankLinkingRoute,
  [Routes.InsufficientBankBalance]: InsufficientBankBalanceRoute,
  [Routes.UnsupportedBank]: UnsupportedBankRoute,
  [Routes.TaxGainHarvest]: TaxGainHarvestRoute,
};
